export const en = {
  assign_guests: 'Allow Clients to be assigned to tasks',
  permission: 'Allow Clients to see tasks created by other clients',
  allow_guests_change_task_status:
    'Allow Clients to change the status of a task',
  change_guest_default_column: 'Send new client feedback to',
  allow_project_summary_email: 'Allow project summary email',
  allow_task_done_email: 'Allow task done email'
};

export type Translations = typeof en;
